import styled from "styled-components";

export default styled.img`
    height: 20px;
    width: 20px;
    object-fit: contain;
    margin-right: 12px;
`;
